import { Box, Checkbox, FormLabel, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ContentType } from '../../interfaces/campaign';
import { useContext } from 'react';
import { CampaignContext } from '../../contexts/CampaignContext';

type ContentTypeProps = {
	action?: string;
};

const ContentTypeBox: React.FC<ContentTypeProps> = ({ action = 'create' }) => {
	const { t } = useTranslation();
	const { setSelectedContentType, selectedContentType } = useContext(CampaignContext);

	const handleCheckboxChange = (type: ContentType) => {
		if (selectedContentType === type) {
			setSelectedContentType(null);
		} else {
			setSelectedContentType(type);
		}
	};

	return (
		<Box className={`mt-4 flex items-center gap-x-4 rounded-lg bg-background-paper p-6`}>
			<Typography className="me-2 text-xl text-text-primary">{t('content_type')}</Typography>
			<Box className="me-16 flex items-center rounded-lg">
				<Checkbox className="m-0" checked={selectedContentType === 'post'} disabled={action === 'create' ? false : true} onChange={() => handleCheckboxChange('post')} />
				<FormLabel className="text-base text-text-primary">{t('post')}</FormLabel>
			</Box>
			<Box className="flex items-center rounded-lg">
				<Checkbox className="m-0" checked={selectedContentType === 'story'} disabled={action === 'create' ? false : true} onChange={() => handleCheckboxChange('story')} />
				<FormLabel className="text-base text-text-primary">{t('story')}</FormLabel>
			</Box>
		</Box>
	);
};

export default ContentTypeBox;
